const streamComponentStyles = (theme) => {
  return {
    mainContainer: {
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#1C2833',
      // borderColor: 'tomato',
      borderWidth: 1,
      borderStyle: 'solid',
      boxShadow: '0 0 6px rgba(0,0,0,0.00)',
      WebkitBoxShadow: '0 0 6px rgba(0,0,0,0.00)',
    },
    retryContStyles: {
      position: 'absolute',
      display: 'flex',
      flex: 1,
      width: '100%',
      height: '100%',
      alignSelf: 'flex-end',
      zIndex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#1C2833',
    },
    greyColor: {
      color: '#99A3A4',
    },
    qualityContainer: {
      position: 'absolute',
      top: 2,
      right: 2,
      left: 'auto',
      bottom: 'auto',
      zIndex: 2000,
      color: '#a9a9a9',
    },
    iconsContainer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      paddingBottom: theme.spacing(1.2),
      justifyContent: 'space-between',
      alignItems: 'center',
      color: '#fff',
      zIndex: 2000,
    },
    volumeCont: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      color: '#fff',
    },
    iconBtnContainer: {
      margin: 5,
      padding: 0,
      paddingRight: 4,
    },
    volSliderStyle: {
      color: '#fff',
      width: theme.spacing(8),
    },
    iconOnClass: {
      fill: '#ffffff',
    },
    iconOffClass: {
      fill: '#ffffff',
    },
    videoClass: {
      width: '100%',
      objectFit: 'cover',
      aspectRatio: '16/9',
      objectPosition: 'center',
    },
  };
};

export default streamComponentStyles;
